module.exports = __webpack_public_path__ + "img/utilities.a1369eac.svg";